import { render } from "./IBNodeDetails.vue?vue&type=template&id=e6623a88"
import script from "./IBNodeDetails.vue?vue&type=script&lang=js"
export * from "./IBNodeDetails.vue?vue&type=script&lang=js"
script.render = render

export default script